import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import CPTCodeSelect from "../CPTCodeSelect";
import CPTCodeSelectW from "../CPTCodeSelectW";
import Icon from "../Icon";
import Switch from "../Switch";
import Meds from "../visit/Meds";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class Workflow extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            info: {},
            iters: {}
        };
    }

    async componentDidMount() {
        await this.fillListAsync('/api/workflow/fieldtype/list', 'fieldTypes');
        await this.fillItemAsync('/api/workflow/get/' + this.props.struct.id, 'struct');
        await this.load();
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/workflow/data/' + this.props.struct.id + '/visit/' + this.props.visit.id);
            if(j.errorCode === 0) {
                this.processData(j.item.data);
                this.setState({ info: j.item.data });
            }
            else if(j.errorCode !== 7)
                this.alert(j.errorMessage);
        }
        catch(e) {
            this.unkownErrorCallback(e);
        }
    }

    processField = (data, field) => {
        var tp = this.getFieldType(field.fieldTypeID);

        // For Multi-Checkbox
        if (tp.htmlElementType === 'checkbox' && tp.isSelector && field.options) {
            try {
                if (data[field.ident]) {
                    let j = JSON.parse(data[field.ident]);
                    if (j) {
                        j.forEach(i => {
                            if (i.selected) {
                                let opt = field.options.find(x => x.value === i.value);
                                if (opt)
                                    opt.selected = true;
                            }
                        });
                    }
                }
            }
            catch (e) {
                console.error('Error', 'processData', e);
            }
        }
        else if (tp.htmlElementType === 'radio') {
            let val = data[field.ident];
            if (val) {
                let opt = field.options.find(x => x.value === val);
                if (opt)
                    opt.selected = true;
            }
        }
    }

    processData = (data) => {
        let struct = { ...this.state.struct };
        let iters = {};
        struct.sections.forEach(section => {
            if (section.isIteration) {
                let sub = JSON.parse(data[section.ident]);
                if(!sub) return;
                sub.forEach(j => {
                    if(!iters[section.ident])
                        iters[section.ident] = [];
                    iters[section.ident].push(j);
                });
            }
            else {
                section.fields.forEach(field => this.processField(data, field));
            }
        });
        this.setState({ struct, iters });
    }

    getFieldType = (id) => {
        return this.state.fieldTypes?.find(i => i.id === parseInt(id));
    }

    setValue = (field, e, iter, iterIdx) => {
        let info = {...this.state.info};
        if(iter)
            iter[field.ident] = e.target.value;
        else
            info[field.ident] = e.target.value;
        this.setState({ info: info });
    }

    setValueRaw = (field, raw, iter, iterIdx) => {
        let info = {...this.state.info};
        if(iter)
            iter[field.ident] = raw;
        else
            info[field.ident] = raw;
        this.setState({ info: info });
    }

    getValue = (field, iter, iterIdx) => {
        if(iter)
            return iter[field.ident] || '';
        else
            return this.state.info[field.ident] || '';
    }

    toggleCheckbox = (field, e, on, iter, iterIdx) => {
        let info = {...this.state.info};
        if(iter)
            iter[field.ident] = on;
        else
            info[field.ident] = on;
        this.setState({ info: info });
    }

    toggleOptionCheckbox = (field, opt, e, on, iter, iterIdx) => {
        let info = {...this.state.info};
        opt.selected = on;
        if(iter)
            iter[field.ident] = JSON.stringify(field.options);
        else
            info[field.ident] = JSON.stringify(field.options);
        this.setState({ info: info });
    }

    setOptionExtra = (field, opt, e, extra, iter, iterIdx) => {
        let info = {...this.state.info};
        opt.extra = extra;
        if(iter)
            iter[field.ident] = JSON.stringify(field.options);
        else
            info[field.ident] = JSON.stringify(field.options);
        this.setState({ info: info });
    }

    getOptionExtra = (field, opt, iter, iterIdx) => {
        let j = JSON.parse(iter ? iter[field.ident] : this.state.info[field.ident]);
        let find = j.find(x => x.value === opt.value);
        if(find)
            return find.extra;
        return '';
    }

    toggleValue = (field, e, opt, iter, iterIdx) => {
        let info = {...this.state.info};
        field.options.forEach(i => {
            i.selected = false;
        });
        opt.selected = true;
        if(iter)
            iter[field.ident] = opt.value;
        else
            info[field.ident] = opt.value;
        this.setState({ info: info });
    }

    placeholder = (s) => {
        return s?.replace(/#/g, '_');
    }

    field = (f, iter, iterIdx) => {
        var tp = this.getFieldType(f.fieldTypeID);
        if (!tp) return null;

        // Radio
        if (tp.htmlElementType === 'radio') {
            return <div>
                {f.options?.map((opt, k) => <div key={k}>
                    <input
                        type="radio"
                        onChange={(e) => this.toggleValue(f, e, opt, iter, iterIdx)}
                        checked={opt.selected}
                    /> {opt.value}
                </div>)}
            </div>;
        }
        // Input
        else if (tp.htmlElement === 'input') {
            if (tp.htmlElementType === 'checkbox') {
                if (tp.isSelector) {
                    return <div>
                        {f.options?.map((opt, kdx) => <div key={kdx}>
                            <Switch
                                checked={opt.selected}
                                onChange={(e) => this.toggleOptionCheckbox(f, opt, e, e.target.checked, iter, iterIdx)}
                                label={opt.value}
                            />
                            {opt.selected && opt.isExtra && <input type="text" className="form-control"
                                onChange={(e) => this.setOptionExtra(f, opt, e, e.target.value, iter, iterIdx)}
                                value={this.getOptionExtra(f, opt, iter, iterIdx)}
                                /> /* EXTRA */}
                        </div>)}
                    </div>;
                }
                else {
                    return <Switch
                        checked={this.getValue(f, iter, iterIdx)}
                        onChange={(e) => this.toggleCheckbox(f, e, e.target.checked, iter, iterIdx)}
                        label={f.name}
                    />;
                }
            }
            else {
                return <input
                    type={tp.htmlElementType}
                    className="form-control"
                    onChange={(e) => this.setValue(f, e, iter, iterIdx)}
                    value={this.getValue(f, iter, iterIdx)}
                    placeholder={this.placeholder(f.fieldFormat)}
                />;
            }
        }
        // Textarea
        else if (tp.htmlElement === 'textarea')
            return <textarea
                className="form-control"
                onChange={(e) => this.setValue(f, e, iter, iterIdx)}
                value={this.getValue(f, iter, iterIdx)}></textarea>;
        // Select
        else if (tp.htmlElement === 'select') {
            return <select className="form-control" onChange={(e) => this.setValue(f, e, iter, iterIdx)} defaultValue={this.getValue(f, iter, iterIdx)}>
                <select>Select</select>
                {f.options?.map((opt, k) => <option key={k} value={opt.value} selected={this.getValue(f, iter, iterIdx) === opt.value}>{opt.value}</option>)}
            </select>;
        }
        // CPT Codes
        else if(tp.htmlElement === 'CPTCodes') {
            return <CPTCodeSelectW
                        currentValues={JSON.parse(this.getValue(f, iter, iterIdx) || '[]')}
                        onChange={(v) => this.setValueRaw(f, JSON.stringify(v), iter, iterIdx)}
                    />
        }
        // Meds
        else if(tp.htmlElement === 'Medications') {
            return <Meds
                    noLabel
                    list={JSON.parse(this.getValue(f, iter, iterIdx) || '[]')}
                    onChange={(v) => this.setValueRaw(f, JSON.stringify(v), iter, iterIdx)}
                />;
        }
        return null;
    }

    submit = async (e) => {
        e?.preventDefault();
        try {
            let iters = this.state.iters;
            let item = {...this.state.struct, data: {...this.state.info, visitid: this.props.visit.id } };
            for(var k in iters) {
                item.data[k] = iters[k];
            }
            let j = await qreq.postAsync('/api/workflow/submit', item);
            if(j.errorCode === 0)
                this.success('Saved!');
            else
                this.alert(j.errorMessage);
        }
        catch(e) {
            this.unkownErrorCallback(e);
        }
    }

    addIteration = (section, data) => {
        if(!data) data = {};
        let iters = {...this.state.iters};
        if(!iters[section.ident])
            iters[section.ident] = [];
        iters[section.ident].push(data);    
        this.setState({ iters });
    }

    removeIteration = (section, iter) => {
        let iters = {...this.state.iters};
        let idx = iters[section.ident].indexOf(iter);
        iters[section.ident].splice(idx, 1);
        this.setState({ iters });
    }

    mapIteration = (section) => {
        return this.state.iters[section.ident];
    }

    render() {
        return (
            <form onSubmit={this.submit}>
                <AppActions>
                    <button type="submit" className="btn btn-lg btn-success">
                        <Icon icon="faSave" /> Save
                    </button>
                </AppActions>
                {this.state.struct?.sections?.map((i, idx) => (
                    i.isIteration ? <>
                        <div key={idx}>
                            {this.mapIteration(i)?.map((j, jdx) => (
                                <Card key={jdx} title={i.name} headerButtons={<button type="button" className="btn btn-danger" onClick={() => this.removeIteration(i, j)}><Icon icon="faTrash" /></button>}>
                                {i.fields.map((f,fdx) => (
                                    <div key={fdx} className="form-group mb-3">
                                        {(this.getFieldType(f.fieldTypeID)?.htmlElementType !== 'checkbox' || this.getFieldType(f.fieldTypeID)?.isSelector) && <label className="form-label">{f.name}</label>}
                                        {this.field(f, j, jdx)}
                                    </div>
                                ))}
                                </Card>
                            ))}
                            <div className="mb-3">
                                <button type="button" className="btn btn-primary" onClick={() => this.addIteration(i)}><Icon icon="faPlus" /> Add {i.name}</button>
                            </div>
                        </div>
                    </> : <Card key={idx} title={i.name}>
                        {i.fields.map((f,fdx) => (
                            <div key={fdx} className="form-group mb-3">
                                {(this.getFieldType(f.fieldTypeID)?.htmlElementType !== 'checkbox' || this.getFieldType(f.fieldTypeID)?.isSelector) && <label className="form-label">{f.name}</label>}
                                {this.field(f)}
                            </div>
                        ))}
                    </Card>
                ))}
            </form>
        );
    }
}

export default withParamsAndNavigate(Workflow);